export const AUTH_TOKEN = "JWT_TOKEN";
export const USER_ID = "USER_ID";
export const IS_SOTRAVEL_ADMIN = "IS_SOTRAVEL_ADMIN";
